import { useModalApi } from '@vivli/core/infrastructure/hook';
import { ModalApiContext, ModalStateContext } from '@vivli/core/infrastructure/context';
import { IContextWrapper } from '@vivli/shared/infrastructure/interface';

/**
 * Owns the modal state and exposes it through two contexts: a STABLE api context (the
 * confirm/message/dismiss/... callbacks, whose reference never changes) and a CHANGING state context
 * (the `modals` array, consumed only by ModalContextWrapper).
 *
 * Because the modal `useState` lives here — below CoreContext — opening/closing a modal re-renders
 * only this provider (and the modal host), never CoreContext consumers such as the data-package
 * uploader. (DEV-485 re-render fix)
 */
export const ModalProvider = ({ children }: IContextWrapper) => {
    const { modalApi, modals } = useModalApi();

    return (
        <ModalApiContext.Provider value={modalApi}>
            <ModalStateContext.Provider value={modals}>{children}</ModalStateContext.Provider>
        </ModalApiContext.Provider>
    );
};
